import CustomPagination from '@/platform/common/components/CustomPagination/CustomPagination';
import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import { localDate } from '@/platform/lib/utils';
import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Container,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    MenuSeparator,
    Segment,
    SegmentContent,
    SegmentFooter,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import {
    EllipsisVerticalIcon,
    EyeIcon,
    PlusIcon,
    TrashIcon,
} from '@heroicons/react/24/outline';
import { router, usePage } from '@inertiajs/react';
import { useState } from 'react';
import AttachModal from './components/AttachModal';
import CreateModal from './components/CreateModal';
import EntitiesModal from './components/EntitiesModal';
import OnboardingIcon from './components/OnboardingIcon';
import ToggleActive from './components/ToggleActive';

const CustomerIndexView = () => {
    const [entitiesModal, setEntitiesModal] = useState(null);
    const [createModal, setCreateModal] = useState(false);
    const [attachModal, setAttachModal] = useState(false);
    const { auth, invitees } = usePage().props;
    const confirm = useConfirmationStore(state => state.confirm);

    const destroy = invitee => {
        router.delete(
            `/customers/${invitee.customer_id}/datahub-invitees/${invitee.id}`,
            {
                preserveScroll: true,
                preserveState: true,
            }
        );
    };

    const handleDelete = invitee => {
        confirm({
            title: 'Uitnodiging verwijderen?',
            description:
                'Weet je zeker dat je deze uitnodiging wilt verwijderen? Dit kan alleen als de uitnodiging niet meer in Datahub bestaat. Deze actie kan niet ongedaan worden gemaakt.',
            confirmLabel: 'Verwijderen',
            onConfirm: close => {
                destroy(invitee);
                close();
            },
        });
    };

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header={`Datahub invitees (${invitees?.meta?.total || 0})`}
                >
                    {auth.permissions?.includes('create datahub invitees') && (
                        <>
                            <Button onClick={() => setAttachModal(true)}>
                                Link bestaande invitee
                            </Button>
                            <Button
                                variant='primary'
                                onClick={() => setCreateModal(true)}
                            >
                                <PlusIcon className='size-5' />
                                Nieuwe invitee
                            </Button>
                        </>
                    )}
                </SegmentHeader>
                <SegmentContent>
                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>E-mailadres</TableHeaderCell>
                                <TableHeaderCell>
                                    Uitnodiging verstuurd
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Onboarding
                                </TableHeaderCell>
                                <TableHeaderCell textAlign='center'>
                                    Actief
                                </TableHeaderCell>
                                <TableHeaderCell />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {invitees?.meta?.total === 0 && (
                                <NoDataRow numberOfColumns={5} />
                            )}

                            {invitees?.data?.map(invitee => (
                                <TableRow key={invitee.id}>
                                    <TableCell>{invitee.email}</TableCell>
                                    <TableCell>
                                        {localDate(invitee.created_at)}
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        <OnboardingIcon invitee={invitee} />
                                    </TableCell>
                                    <TableCell textAlign='center'>
                                        <ToggleActive invitee={invitee} />
                                    </TableCell>
                                    <TableCell
                                        className='w-px'
                                        singleLine
                                        textAlign='right'
                                    >
                                        <Menu>
                                            <MenuButton>
                                                <EllipsisVerticalIcon className='size-5' />
                                            </MenuButton>
                                            <MenuItems anchor='bottom end'>
                                                <MenuItem
                                                    onClick={() =>
                                                        setEntitiesModal(
                                                            invitee
                                                        )
                                                    }
                                                    icon={EyeIcon}
                                                >
                                                    Wijzigen
                                                </MenuItem>

                                                {auth?.permissions?.includes(
                                                    'delete datahub invitees'
                                                ) && (
                                                    <>
                                                        <MenuSeparator />
                                                        <MenuItem
                                                            className='text-red-600'
                                                            onClick={() =>
                                                                handleDelete(
                                                                    invitee
                                                                )
                                                            }
                                                            icon={TrashIcon}
                                                        >
                                                            Verwijderen
                                                        </MenuItem>
                                                    </>
                                                )}
                                            </MenuItems>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>
                <SegmentFooter>
                    <CustomPagination
                        meta={invitees?.meta}
                        only={['invitees']}
                    />
                </SegmentFooter>
            </Segment>

            {entitiesModal?.id && (
                <EntitiesModal
                    invitee={entitiesModal}
                    onClose={() => setEntitiesModal(null)}
                />
            )}

            {createModal && (
                <CreateModal onClose={() => setCreateModal(false)} />
            )}

            {attachModal && (
                <AttachModal onClose={() => setAttachModal(false)} />
            )}
        </Container>
    );
};

export default CustomerIndexView;
